__turbopack_context__.v({
  "textRotate": "RotatingText-module__Ck-m6q__textRotate",
  "textRotateElement": "RotatingText-module__Ck-m6q__textRotateElement",
  "textRotateLines": "RotatingText-module__Ck-m6q__textRotateLines",
  "textRotateSpace": "RotatingText-module__Ck-m6q__textRotateSpace",
  "textRotateSrOnly": "RotatingText-module__Ck-m6q__textRotateSrOnly",
  "textRotateWord": "RotatingText-module__Ck-m6q__textRotateWord",
});
